import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (paidAt: string) => Promise<unknown> | void;
  isSubmitting?: boolean;
}

export function MarkPaidDialog({ open, onOpenChange, onConfirm, isSubmitting }: Props) {
  const [paidAt, setPaidAt] = useState<string>(today());
  const valid = /^\d{4}-\d{2}-\d{2}$/.test(paidAt);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Marcar como pago</DialogTitle>
          <DialogDescription>
            Informe a data em que o pagamento foi confirmado.
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <label htmlFor="paid-at" className="mb-2 block text-sm font-medium">
            Data do pagamento
          </label>
          <Input
            id="paid-at"
            type="date"
            value={paidAt}
            max={today()}
            onChange={(e) => setPaidAt(e.target.value)}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => valid && onConfirm(paidAt)}
            disabled={!valid || isSubmitting}
          >
            {isSubmitting ? 'Salvando…' : 'Confirmar pagamento'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
